/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { List, ListItem, Typography } from "@mui/material";

import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("contracts.title")}
      </Typography>
      <hr />

      {/* Membro Responsável */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("contracts.responsible_member.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("contracts.responsible_member.body")}
        </Box>
      </Typography>

      {/* Validade */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("contracts.validity.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("contracts.validity.body")}
        </Box>
      </Typography>

      {/* Ciclo Tarifário */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("contracts.tariff_cycle.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("contracts.tariff_cycle.body")}
        </Box>
      </Typography>

      {/* Tipo de Contrato */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("contracts.contract_type.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("contracts.contract_type.body")}
        </Box>
      </Typography>

      {/* Métodos */}
      <Box ml={6} mt={2}>
        <List component="ul">
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("contracts.methods.indexed_ks.title")}
              </Typography>{" "}
              {t("contracts.methods.indexed_ks.desc")}
            </Typography>
          </ListItem>

          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("contracts.methods.indexed_simple.title")}
              </Typography>{" "}
              {t("contracts.methods.indexed_simple.desc")}
            </Typography>
          </ListItem>

          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("contracts.methods.fixed.title")}
              </Typography>{" "}
              {t("contracts.methods.fixed.desc")}
            </Typography>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}

export default HelpModalScreen;
